import { PreviewRegistration } from './types';

let current: PreviewRegistration | null = null;

export function registerPreview(registration: PreviewRegistration) {
  current = registration;
}

export function unregisterPreview() {
  current = null;
}

export function getCurrentPreview() {
  return current;
}
